export * from './AddBookingDetailsRequest';
export * from './CancellationBookingRequest';
export * from './ChangeBookingPaymentStatusRequest';
export * from './ChangeExamEventRequest';
export * from './CreateBookingRequest';
export * from './DoPaymentRequest';
export * from './RegisterRequest';
export * from './UniversityCreateRequest';
export * from './UniversityUpdateRequest';
